import React from 'react';
import { useTranslation } from 'react-i18next';
import MFELoader from 'routes/components/MFELoader';
import { MFE_WC_EXPORTS } from 'shared/constants';
import { HostConfigType, SurveyServAuthType } from 'shared/types';
import { RoleType } from 'utils/access-control';
import config from 'utils/config';

export type HostPropType = {
  role: RoleType;
  surveyServAuthInfo?: SurveyServAuthType;
  hostConfig: HostConfigType;
  product: string;
};

function ThemeList(hostProps: HostPropType) {
  const { t } = useTranslation();
  return (
    <div className="App" style={{ height: '100%', background: '#fff' }}>
      <survey-components
        url={config.SURVEY_MICROFRONTEND_REMOTE}
        module-name={MFE_WC_EXPORTS.name}
        export-name={MFE_WC_EXPORTS.modules.ThemeListWC}
        fn="default"
        data={JSON.stringify({
          ...hostProps,
        })}
      >
        <div slot="loading">
          <MFELoader wcLoading />
        </div>
        <p slot="failure">{t('loading_failed')}</p>
      </survey-components>
    </div>
  );
}

export default ThemeList;
